import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "scanCounter", "qrCard"]

  open() {
    this.dialogTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.dialogTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  keydown(event) {
    if (event.key === "Escape") this.close()
  }

  toggleScan(event) {
    const card = event.currentTarget
    card.classList.toggle("scanned")
    this.updateScanCounter()
  }

  updateScanCounter() {
    if (!this.hasScanCounterTarget) return
    const scanned = this.qrCardTargets.filter(c => c.classList.contains("scanned")).length
    this.scanCounterTarget.textContent = scanned
  }
}
